import { render, staticRenderFns } from "./gtr-module-icon.vue?vue&type=template&id=855e21ba&scoped=true"
import script from "./gtr-module-icon.vue?vue&type=script&lang=ts"
export * from "./gtr-module-icon.vue?vue&type=script&lang=ts"
import style0 from "./gtr-module-icon.vue?vue&type=style&index=0&id=855e21ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855e21ba",
  null
  
)

export default component.exports